import dsBridge from 'dsbridge'
import { AppType } from '@/utils'
function isNativeReady() {
  return dsBridge && AppType.isInApp()
}
function isMethodReady(functionName) {
  return dsBridge && dsBridge.hasNativeMethod(functionName)
}

export function setTitle(name) {
  if (isNativeReady() && isMethodReady('setTitle')) {
    dsBridge.call('setTitle', name)
  }
}

export function callShare(params) {
  if (isNativeReady() && isMethodReady('callShare')) {
    // {title: title, desc: desc, link: sharingUrl, imgUrl: imgUrl}
    dsBridge.call('callShare', params)
  }
}

export function enableShare(params) {
  if (isNativeReady() && isMethodReady('enableShare')) {
    // {title: title, desc: desc, link: sharingUrl, imgUrl: imgUrl}
    dsBridge.call('enableShare', params)
  }
}

export function disableShare() {
  if (isNativeReady() && isMethodReady('disableShare')) {
    dsBridge.call('disableShare')
  }
}

export function enableMenuBar(params) {
  /*
  bookmark:{
      alreadyBookmarked:data.messages.data.alreadyBookmarked,
      contentType:"video",
      contentId:videoId,
      objType:objType,
      objId:objId
  },
  report:{
      objId:videoId,
      objType:"video"
  }
  */
  if (isNativeReady() && isMethodReady('enableMenuBar')) {
    dsBridge.call('enableMenuBar', params)
  }
}

export function sendPassport(passport) {
  if (isNativeReady() && isMethodReady('sendPassport')) {
    dsBridge.call('sendPassport', passport)
  }
}

export function testNatvieSync(name) {
  if (isNativeReady() && isMethodReady('testNatvieSync')) {
    // 同步调用
    var str = dsBridge.call('testNatvieSync', 'Hello Sync')
    alert(str)
  }
}

export function testNatvieAsyn(name) {
  if (isNativeReady() && isMethodReady('testNatvieAsyn')) {
    // 异步调用
    dsBridge.call('testNatvieAsyn', 'Hello Asyn', function (res) {
      alert(res)
    })
  }
}

if (isNativeReady()) {
  dsBridge.register('testJSSync', function(name) {
    return name + ' Hello Sync'
  })
}

if (isNativeReady()) {
  dsBridge.registerAsyn('testJSAsyn', function(name, responseCallback) {
    responseCallback(name + ' Hello Asyn')
  })
}

// export default DsBridage



// WEBPACK FOOTER //
// ./src/libs/ds-bridge.js